import translates from './fr.json';
import restNotifications from './notifiers.json';

export default {
  fr: { ...translates, ...restNotifications },
};
